import {RootState} from '../store';

export const selectFillerAudioFileList = (state: RootState) =>
  state.production.fillerAudioFileList;

export const selectMP3Data = (state: RootState) =>
  state.production.mP3DataComponentState;

export const selectProductionRedactionTagList = (state: RootState) =>
  state.production.redactionTagList;

export const selectSecurityGroupId = (state: RootState) =>
  state.production.securityGroupId;

export const selectEditModeProductionId = (state: RootState) =>
  state.production.editModeProductionId;
